module.exports = __webpack_public_path__ + "img/picto-affiliation.f68fd797.svg";